import { VOUCHERS, VOUCHERS_PAGINATE, NOTIFICATIONS_INCLUDE } from '@store/types'
import shortly from 'vuex-shortly'
import axios from 'axios'
import formatedFilters from '@helpers/formatAxiosGetFilters'

const state = {
  vouchers: [],
  paginate: {}
}

const getters = {
  [VOUCHERS]: 'vouchers',
  [VOUCHERS_PAGINATE]: 'paginate'
}

const mutations = {
  [VOUCHERS]: 'vouchers',
  [VOUCHERS_PAGINATE]: 'paginate'
}

const actions = {
  [VOUCHERS]: async ({ commit, dispatch }, payload = {}) => {
    const filters = formatedFilters(payload)
    try {
      const response = await axios.get(`/vouchers?${filters}`)
      if (response && response.data && response.data.data) {
        const { data: vouchers, ...paginate } = response?.data || {}
        commit(VOUCHERS, vouchers)
        commit(VOUCHERS_PAGINATE, paginate.meta)
        return response
      } else {
        dispatch(NOTIFICATIONS_INCLUDE, Error('Não foi possível obter os saques'))
      }
    } catch (error) {
      dispatch(NOTIFICATIONS_INCLUDE, Error('Não foi possível obter os saques'))
    }
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/vouchers.js